import { render, staticRenderFns } from "./PeriodPayouts.vue?vue&type=template&id=078bb7a4&scoped=true&"
import script from "./PeriodPayouts.vue?vue&type=script&lang=js&"
export * from "./PeriodPayouts.vue?vue&type=script&lang=js&"
import style0 from "./PeriodPayouts.vue?vue&type=style&index=0&id=078bb7a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078bb7a4",
  null
  
)

export default component.exports